import {AuthLoginModel} from '../../model/auth_login.model'
import {AuthService} from '../../auth/auth.service';
import {AuthUserModel} from '../../model/auth_user.model'
import {Component,Input ,OnInit,OnDestroy} from '@angular/core';
import {ActivatedRoute,Router} from '@angular/router';
import Typewriter from 't-writer.js'



@Component({
    moduleId:module.id,
	selector : 'login',
	templateUrl : 'login.component.html',
    styleUrls:['login.component.scss']


})

export class LoginComponent implements OnInit {

    mLogin:AuthLoginModel;
    mApiService:AuthService;
    errorMessage: string = '';
    isLoading: boolean = false;
    loginStatus:string=''
    route:ActivatedRoute;
    router:Router;

     constructor(mApiService:AuthService,route:ActivatedRoute,router:Router){


   this.mApiService=mApiService;
   this.mLogin=new AuthLoginModel();
   this.router=router;
   this.route=route;

   }
  ngOnInit() {
    const target = document.querySelector('.tw');
    const writer = new Typewriter(target, {
      loop: true,
      typeSpeed: 80,
      deleteSpeed: 80,
      typeColor: '#2D426D'
    })

    writer
      .type('Hello!')
      .rest(500)
      .changeOps({ deleteSpeed: 80 })
      .remove(6)
      .type('Welcome.')
      .rest(500)
      // .remove(4)
      // .type('synchronize callbacks')
      // .rest(500)
      // .changeOps({ deleteSpeed: 20 })
      // .remove(21)
      // .type('change options on the go')
      // .rest(500)
      .clear()
      .start()
  }


   login()
   {

         this.loginStatus='';
          this.isLoading=true;
          this.mApiService.login(this.mLogin.username,this.mLogin.password)
         .subscribe(
           p=>{

              this.isLoading=false;
              this.handleLogin(p)

           },
           e => {

                this.errorMessage = e;

               if('login_failure' in e)
               this.loginStatus= e.login_failure[0];
                else
                this.loginStatus='An error occured';

                this.isLoading=false;

           },
           ()=>this.isLoading=false
         )


   }

   handleLogin(user:AuthUserModel)
   {

       if(user)
       {
           localStorage.setItem("userId",user.userId);
           localStorage.setItem("userFullName",user.userFullName);
           localStorage.setItem("userName",user.userName);
           localStorage.setItem("userProgramCategory",user.userProgramCategory+"");
           console.log("Yupee Login success");



        let linkName:string=  this.getNavigateLink(user.roles);

          let link=[linkName]
          this.router.navigate(link);

       }
       else
       {
               this.loginStatus='Invalid UserName or Password';

       }

   }
   getNavigateLink(roles:string[]):string
   {

    console.log(roles);

     let link="dashboard"
     if(roles.indexOf("Supervisor")>0)
     {
         link="trainerDashboard";
     }


     else if(roles.indexOf("Student")>0)
     {
          link="traineeDashboard";
     }


     return link;


   }



}
